import(/* webpackMode: "eager", webpackExports: ["default","success","error","loading","promise","dismiss"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/JobDetails.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/loading.css");
